export default "[Here you can insert the release notes for this software...]"